var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-inline"},[_c('div',{staticClass:"d-inline-block",staticStyle:{"width":"36px"}},[_c('v-icon',{attrs:{"small":!_vm.data.isEquipment}},[_vm._v("mdi-"+_vm._s(_vm.data.isEquipment ? 'folder-' : '')+"cog")])],1),_c('span',[_vm._v(_vm._s(_vm.data.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }